class SubCollectionLinks extends HTMLElement {
  constructor() {
    super();
    this.container = null;
    this.scrollLeftBtn = null;
    this.scrollRightBtn = null;
    this.scrollAmount = 300;
  }

  connectedCallback() {
    this.container = this.querySelector('.sub-collections__scroll');
    this.scrollLeftBtn = this.querySelector('.sub-collections__arrow--left');
    this.scrollRightBtn = this.querySelector('.sub-collections__arrow--right');

    if (!this.container) return;

    this.checkOverflow();
    this.toggleArrows();

    this.scrollLeftBtn?.addEventListener('click', () => this.container.scrollBy({ left: -this.scrollAmount, behavior: 'smooth' }));
    this.scrollRightBtn?.addEventListener('click', () => this.container.scrollBy({ left: this.scrollAmount, behavior: 'smooth' }));

    this.container.addEventListener('scroll', this.toggleArrows.bind(this));
    window.addEventListener('resize', () => {
      this.checkOverflow();
      this.toggleArrows();
    });
  }

  checkOverflow() {
    const scrollable = this.container.scrollWidth > this.container.clientWidth;
    this.container.classList.toggle('sub-collections__scroll--centered', !scrollable);
  }

  toggleArrows() {
    if (!this.scrollLeftBtn || !this.scrollRightBtn) return;

    const atStart = this.container.scrollLeft === 0;
    const atEnd = Math.ceil(this.container.scrollLeft + this.container.offsetWidth) >= this.container.scrollWidth;

    this.scrollLeftBtn.style.display = atStart ? 'none' : 'block';
    this.scrollRightBtn.style.display = atEnd ? 'none' : 'block';
  }
}

if (!customElements.get('sub-collection-links')) {
  customElements.define('sub-collection-links', SubCollectionLinks);
}
